import { Vector } from "@/components/ui/vector";
import { ComponentPropsWithRef } from "react";

type GalleryButtonArrowProps = Omit<
  ComponentPropsWithRef<"button">,
  "children"
> & {
  position?: "left" | "right";
};

export const GalleryButtonArrow = (props: GalleryButtonArrowProps) => {
  const {
    className = "",
    position = "left",

    ...restProps
  } = props;

  return (
    <button className={className} type="button" {...restProps}>
      <Vector name={`arrow-${position}`} className="w-6 h-6" />
    </button>
  );
};
